import { createThunkRequest, makeRequest, POST } from '@webapp/account/src/libs/request';

import { getUserToken } from '@webapp/common/lib/cookies';

import { mapFile } from './map';

export const uploadFiles = createThunkRequest(
    'filemanager/uploadFile',
    async ({ surveyId, folder, files }: { surveyId: number; folder: string; files: Array<File> }) => {
        const formData = new FormData();

        for (const file of files) {
            formData.append('upfile[]', file);
        }

        const userToken = getUserToken();
        formData.append('token', userToken);

        if (surveyId) {
            formData.append('surveyId', String(surveyId));
        }

        if (folder) {
            formData.append('folder', String(folder));
        }

        const resp = await makeRequest({
            path: 'upload/user/file',
            method: 'POST',
            body: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        return {
            message: resp.message,
            files: resp.files?.map(mapFile) || [],
        };
    },
);

export const getFiles = createThunkRequest(
    'filemanager/getFiles',
    async () => {
        const { rows } = await POST(`list/user_file`);

        return {
            files: rows?.map(mapFile),
        };
    },
    { notify: false, notifyError: true },
);

export const removeFile = createThunkRequest(
    'filemanager/removeFile',

    async ({ fileId }: { fileId: number }) => {
        const { message } = await POST(`delete/file`, { id: fileId });

        return {
            message,
            fileId,
        };
    },
);
